import { GetCurrentDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { dateToString } from './dates'
import { GraphQLClient } from './graphql/provider'

export interface TrackingData {
  userId: string
  userEmail: string | null | undefined
  userIsAdmin: boolean
  companyName: string
  companyId: string
  companySize: string
}

export const buildTrackingData = (apolloClient: GraphQLClient): Promise<TrackingData | null> => {
  return apolloClient
    .query({
      query: GetCurrentDocument,
      fetchPolicy: 'cache-only',
      variables: {
        contractVersionsActiveOn: dateToString(moment(), 'backend'),
      },
    })
    .then((response) => {
      if (response.data) {
        const current = response.data.apiCore.currentsConnection.edges[0]?.node

        if (current) {
          const { access, company, email } = current

          return {
            userId: access.id,
            userEmail: email,
            userIsAdmin: false,
            companyId: company.id,
            companyName: company.name,
            companySize: company.size,
          }
        }
      }

      return null
    })
    .catch(() => null)
}
